import styled from 'styled-components/native';

export default styled.Text<{ bold?: boolean }>`
  font-size: 20px;
  font-family: BasierCircle-Regular;
  color: ${({ theme }) => theme.colors.primaryActive};
  letter-spacing: -0.45px;
`;
